import { render, staticRenderFns } from "./CreateManualParameter.vue?vue&type=template&id=7536ec7c&scoped=true"
import script from "./CreateManualParameter.vue?vue&type=script&lang=js"
export * from "./CreateManualParameter.vue?vue&type=script&lang=js"
import style0 from "./CreateManualParameter.vue?vue&type=style&index=0&id=7536ec7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536ec7c",
  null
  
)

export default component.exports